import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02501476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-container" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "desktop-tabs" }
const _hoisted_4 = { class: "d-flex flex-column desktop-container-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop-item-header" }, "Faturamento de Expedição", -1))
const _hoisted_6 = { class: "desktop-item-header-date" }
const _hoisted_7 = {
  key: 0,
  class: "info"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Filtros ")
const _hoisted_9 = {
  key: 1,
  class: "info",
  id: "dropdown"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Filtros ")
const _hoisted_11 = { class: "desktop-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_DassIcon = _resolveComponent("DassIcon")!
  const _component_ListFilter = _resolveComponent("ListFilter")!
  const _component_FilterModal = _resolveComponent("FilterModal")!
  const _component_ListFilterUnits = _resolveComponent("ListFilterUnits")!
  const _component_ListFilterBrands = _resolveComponent("ListFilterBrands")!
  const _component_ListFilterSegments = _resolveComponent("ListFilterSegments")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentFormattedDate()), 1)
        ]),
        _createVNode(_component_Tabs)
      ]),
      (_ctx.isEcomm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
            }, [
              _createVNode(_component_DassIcon, {
                token: "icon-action-filter_alt",
                size: "25"
              }),
              _hoisted_8
            ]),
            _createVNode(_component_FilterModal, {
              visibility: _ctx.modalFilter,
              "onUpdate:visibility": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalFilter) = $event)),
              "filter-tag": _ctx.filterTag,
              "has-modification": true,
              onSaveChanges: _ctx.saveChanges,
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel = !_ctx.cancel))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ListFilter, {
                  "list-filter": _ctx.units,
                  "onUpdate:list-filter": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.units) = $event)),
                  selectAll: _ctx.unitsFilter,
                  "onUpdate:selectAll": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.unitsFilter) = $event)),
                  labelFilter: "Unidade",
                  onValueSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeFilter($event))),
                  onClearFilter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterTag = [])),
                  onAllUnits: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkAllFilter($event))),
                  "cancel-prop": _ctx.cancel
                }, null, 8, ["list-filter", "selectAll", "cancel-prop"])
              ]),
              _: 1
            }, 8, ["visibility", "filter-tag", "onSaveChanges"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
            }, [
              _createVNode(_component_DassIcon, {
                token: "icon-action-filter_alt",
                size: "25"
              }),
              _hoisted_10
            ]),
            _createVNode(_component_FilterModal, {
              visibility: _ctx.modalFilter,
              "onUpdate:visibility": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalFilter) = $event)),
              "filter-tag": _ctx.filterTagEcomm,
              hasModification: _ctx.alterationCheckAll,
              onSaveChanges: _ctx.saveChangesEcomm,
              onCancel: _ctx.cancelEcomm,
              onCloseModal: _ctx.closeModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ListFilterUnits, {
                  "billing-units-filter": _ctx.filterUnits,
                  onValueSelected: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changedFilter($event, 'units'))),
                  onFilterTag: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tagsUnits($event))),
                  onAllFilter: _ctx.allfilters
                }, null, 8, ["billing-units-filter", "onAllFilter"]),
                _createVNode(_component_ListFilterBrands, {
                  brandFilter: _ctx.filterBrands,
                  onValueSelected: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changedFilter($event, 'brand'))),
                  onFilterTag: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tagsBrands($event))),
                  onAllFilter: _ctx.allfilters
                }, null, 8, ["brandFilter", "onAllFilter"]),
                _createVNode(_component_ListFilterSegments, {
                  "segments-filter": _ctx.filterSegments,
                  onValueSelected: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changedFilter($event, 'segment'))),
                  onFilterTag: _cache[14] || (_cache[14] = ($event: any) => (_ctx.tagsSegments($event))),
                  onAllFilter: _ctx.allfilters
                }, null, 8, ["segments-filter", "onAllFilter"])
              ]),
              _: 1
            }, 8, ["visibility", "filter-tag", "hasModification", "onSaveChanges", "onCancel", "onCloseModal"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_view)
    ])
  ]))
}